module.exports = new __parcel__URL__("little_lemon_tree_level_3.74abba45.png").toString();